<svelte:head>
  {#if currentSession}
  <meta property="og:image" content={currentSession.poster}>
  <meta property="twitter:image" content={currentSession.poster}>
  {/if}
</svelte:head>
<style src='./style.scss'>

</style>

{#if currentSession && canPlay}
<div class="mbsc-col-12 mbsc-col-lg-9">
  <PlayerCore
    videoClass='free-class-player'
    frontCamera={currentSession.streams._720.front}
    backCamera={currentSession.streams._720.back}
    poster={currentSession.poster}
    bind:videoPlayer={classPlayer}
    sessionId={currentSession.id}
  ></PlayerCore>
</div>
<div class="mbsc-col-12 mbsc-col-lg-3">
  <VideoSections
    on:sectionSelected={onSectionSelected}
    sections={currentSession.sections}
  ></VideoSections>
</div>
<VideoDetails
  name={currentSession.details.name}
  id={currentSession.id}
  details={currentSession.details}
  videoInfo={currentSession.videoInfo}
  hideContent={hideInfo}
></VideoDetails>
{:else if currentSession && !canPlay}
<div class="mbsc-col-12">
  <FeaturedImage
    title="D-NS Session #{currentSession.id}"
    subtitle="Actualiza tu membresía para poder seguir viendo este video."
    featured={currentSession.poster}
  ></FeaturedImage>
</div>
<VideoDetails
  name={currentSession.details.name}
  id={currentSession.id}
  details={currentSession.details}
  videoInfo={currentSession.videoInfo}
  hideContent={hideInfo}
></VideoDetails>
{/if}

<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';

  import PlayerCore from '@Components/PlayerCore/index.svelte';
  import VideoSections from '@Components/VideoSections/index.svelte';
  import VideoDetails from '@Components/VideoDetails/index.svelte';
  import FeaturedImage from '@Components/FeaturedImage/index.svelte';

  import { Sessions, AWSAuth, Navigation, AWSAnalytics } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  const dispatch = createEventDispatcher();

  export let sessionId = null;
  export let hideInfo = false;
  
  let currentSession = null;

  let sessions = [];
  let classPlayer;
  let canPlay = false;

  let onSectionSelected = (evt) => {
    if (DEBUG) console.log("Init: " + classPlayer.currentTime());
    if (DEBUG) console.log("Going to sec: " + evt.detail.section);
    if (classPlayer) {
      classPlayer.ready(() => {
        if (classPlayer.currentTime() <= 1) {
          classPlayer.play();
        }
        classPlayer.currentTime(evt.detail.section);
      });
    }
  };

  afterUpdate(() => {});

  onMount(async () =>{
    AWSAuth.isAnonymous().then(async response => {
      const subscription = await AWSAuth.hasValidSubscription();
      // return all sessions for SEO
      sessions = Sessions.getSessions(true);
      if (sessionId === null) {
        const maxLength = sessions.length;
        const randomSession = Math.floor(Math.random() * maxLength);
        currentSession = sessions[randomSession];
      } else {
        sessions.forEach(element => {
          if (element.id === sessionId) {
            currentSession = element;
          }
        });
      }
      if (currentSession === null) {
        Navigation.goTo('classes');
        return;
      }
      if ((subscription === 'not authenticated') || (!subscription)) {
        canPlay = false;
      }else if ((subscription === 'free') && (currentSession.isFree === true)) {
        canPlay = true;
      }else if (subscription === true){
        canPlay = true;
      }else{
        canPlay = false;
      }
    });
  });
</script>
